/* Actual size viewer for pendants, chains and bracelets. Shares screen calibration with the ring sizer. */
// Reads a pendant's size from its description text. Returns null if no usable size.
function parsePendantSpec(text){
  if (!text) return null;
  var t = String(text).replace(/\s+/g, ' ').replace(/[\u201D\u201C\u2033]/g, '"').replace(/[\u00D7]/g, 'x');
  var re = /\bDimensions?\b\s*:?\s*/gi, m = null, mm;
  while ((mm = re.exec(t))){
    var rest = t.slice(re.lastIndex, re.lastIndex + 160);
    if (/^[^.]{0,25}\d/.test(rest)){ m = [null, rest]; break; }
  }
  if (!m) return null;
  var d = m[1].split(/\b(?:Pendant fits|Bail Opening|Bail Fits|Chain Fit|Chain Not|Chain Included|Finish|Construction|Estimated|Approximate|Purity|Weight|Material|Stones?|Bail Customizable)\b/i)[0];
  var out = { raw: d.trim(), bail: 'unknown' };
  var lower = d.toLowerCase();
  if (/(not including|without|excluding|w\/o)( the)? bail/.test(lower)) out.bail = 'excluded';
  else if (/(including|with|incl\.?)( the)? bail/.test(lower)) out.bail = 'included';

  // "1.7" in height including bail; 1.37" without bail" -> prefer the including-bail number
  var parts = d.split(/;/);
  if (parts.length > 1){
    for (var i = 0; i < parts.length; i++){
      if (/(including|with)( the)? bail/i.test(parts[i]) && !/(not including|without)/i.test(parts[i])){ d = parts[i]; out.bail = 'included'; break; }
    }
  }
  var toMm = function(num, unit){ num = parseFloat(num); return /mm/i.test(unit) ? num : num * 25.4; };
  var NUM = '(\\d+(?:\\.\\d+)?)\\s*(mm|"|in(?:ch(?:es)?)?\\b|\'\')';

  // "59.2mm x 49.2mm" or "3.25" height x 2" width"
  var pair = d.match(new RegExp(NUM + '\\s*(height|tall|h|width|wide|w)?\\s*x\\s*' + NUM + '\\s*(height|tall|h|width|wide|w)?', 'i'));
  if (pair){
    var a = toMm(pair[1], pair[2]), b = toMm(pair[4], pair[5]);
    var la = (pair[3] || '').toLowerCase(), lb = (pair[6] || '').toLowerCase();
    if (/^w/.test(la) || /^(h|t)/.test(lb)) { out.heightMm = b; out.widthMm = a; }
    else if (/^(h|t)/.test(la) || /^w/.test(lb)) { out.heightMm = a; out.widthMm = b; }
    else { out.dimsMm = [a, b]; }            // order unknown: matched to the photo's shape later
  }
  var dia = d.match(new RegExp(NUM + '\\s*(?:in\\s+)?diameter', 'i')) || d.match(new RegExp('diameter\\s*(?:of\\s*)?' + NUM, 'i'));
  if (dia && !pair) out.diameterMm = toMm(dia[1], dia[2]);
  if (!pair && !out.diameterMm){
    var h = d.match(new RegExp(NUM + '\\s*(?:in\\s+)?(?:height|tall|high|long|length)', 'i')) || d.match(new RegExp('(?:height|tall)\\s*(?:of\\s*)?' + NUM, 'i'));
    var w = d.match(new RegExp(NUM + '\\s*(?:in\\s+)?(?:width|wide)', 'i'));
    if (h) out.heightMm = toMm(h[1], h[2]);
    if (w) out.widthMm = toMm(w[1], w[2]);
    if (!h && !w){
      var any = d.match(new RegExp(NUM, 'i'));
      if (any) out.heightMm = toMm(any[1], any[2]);
    }
  }
  if (!out.heightMm && !out.widthMm && !out.diameterMm && !out.dimsMm) return null;
  // bail / chain fit
  var bf = t.match(/(?:Bail Opening|Bail Fits(?: Chains)?(?: up to)?|Chain Fit(?: Up to)?)\s*:?\s*(?:chains?\s*)?(?:up to\s*)?(\d+(?:\.\d+)?)\s*mm/i);
  if (bf) out.bailMm = parseFloat(bf[1]);
  else { var bf2 = t.match(/fits up to an?\s*(\d+(?:\.\d+)?)\s*mm chain/i); if (bf2) out.bailMm = parseFloat(bf2[1]); }
  var all = [out.heightMm, out.widthMm, out.diameterMm].concat(out.dimsMm || []).filter(Boolean);
  for (var k = 0; k < all.length; k++) if (all[k] < 4 || all[k] > 160) return null;
  return out;
}
// Finds the pendant in a product photo, cuts it out, and works out millimetres per pixel from the listed size.
// Returns { ok:true, canvas, mmPerPx, heightMm, widthMm } or { ok:false, reason }.
function detectPendant(img, spec){
  var MAX = 480;
  var nw = img.naturalWidth, nh = img.naturalHeight;
  var sc = Math.min(1, MAX / Math.max(nw, nh));
  var W = Math.round(nw * sc), H = Math.round(nh * sc), N = W * H;
  var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
  var cx = cv.getContext('2d', { willReadFrequently: true });
  cx.drawImage(img, 0, 0, W, H);
  var px;
  try { px = cx.getImageData(0, 0, W, H).data; } catch (e) { return { ok:false, reason:'image-blocked' }; }

  var gold = new Uint8Array(N), neutral = new Uint8Array(N);
  for (var i = 0; i < N; i++){
    var r = px[i*4] / 255, g = px[i*4+1] / 255, b = px[i*4+2] / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), d = mx - mn, s = mx ? d / mx : 0, h = 0;
    if (d){
      if (mx === r) h = 60 * (((g - b) / d) % 6); else if (mx === g) h = 60 * ((b - r) / d + 2); else h = 60 * ((r - g) / d + 4);
      if (h < 0) h += 360;
    }
    gold[i] = (h >= 28 && h <= 66 && s >= 0.2 && mx >= 0.42) ? 1 : 0;
    neutral[i] = (s < 0.14 && mx > 0.74) ? 1 : 0;
  }

  function morph(m, it, dilate){
    var a = m, bb;
    for (var k = 0; k < it; k++){
      bb = new Uint8Array(N);
      for (var y = 0; y < H; y++) for (var x = 0; x < W; x++){
        var o = y * W + x, v = dilate ? 0 : 1;
        for (var dy = -1; dy <= 1; dy++){ var yy = y + dy; if (yy < 0 || yy >= H){ if (!dilate) v = 0; continue; }
          for (var dx = -1; dx <= 1; dx++){ var xx = x + dx; if (xx < 0 || xx >= W){ if (!dilate) v = 0; continue; }
            var q = a[yy * W + xx]; if (dilate && q) v = 1; if (!dilate && !q) v = 0; } }
        bb[o] = v;
      }
      a = bb;
    }
    return a;
  }
  var open = function(m, n){ return morph(morph(m, n, false), n, true); };
  var close = function(m, n){ return morph(morph(m, n, true), n, false); };

  function components(m){
    var lab = new Int32Array(N), comps = [], stack = new Int32Array(N);
    for (var i = 0; i < N; i++){
      if (!m[i] || lab[i]) continue;
      var id = comps.length + 1, sp = 0, area = 0, x0 = W, x1 = 0, y0 = H, y1 = 0, sx = 0, sy = 0;
      stack[sp++] = i; lab[i] = id;
      while (sp){
        var p = stack[--sp], x = p % W, y = (p - x) / W; area++; sx += x; sy += y;
        if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
        if (x > 0 && m[p-1] && !lab[p-1]){ lab[p-1] = id; stack[sp++] = p-1; }
        if (x < W-1 && m[p+1] && !lab[p+1]){ lab[p+1] = id; stack[sp++] = p+1; }
        if (y > 0 && m[p-W] && !lab[p-W]){ lab[p-W] = id; stack[sp++] = p-W; }
        if (y < H-1 && m[p+W] && !lab[p+W]){ lab[p+W] = id; stack[sp++] = p+W; }
      }
      comps.push({ id:id, area:area, x0:x0, x1:x1, y0:y0, y1:y1, cx:sx/area, cy:sy/area });
    }
    return { lab:lab, comps:comps };
  }
  var edge = Math.max(2, Math.round(Math.max(W, H) * 0.012));
  function touches(c){ return c.x0 <= edge || c.y0 <= edge || c.x1 >= W - 1 - edge || c.y1 >= H - 1 - edge; }

  function pick(m){
    var cc = components(m), best = null, second = null;
    var diag = Math.hypot(W, H);
    cc.comps.forEach(function(c){
      if (c.area < N * 0.002 || touches(c)) return;
      c.score = c.area * (1.25 - Math.hypot(c.cx - W/2, c.cy - H/2) / diag * 2);
      if (!best || c.score > best.score){ second = best; best = c; } else if (!second || c.score > second.score) second = c;
    });
    if (!best) return null;
    var keep = [best.id];
    // join nearby pieces that belong together (e.g. a bail separated by a glint)
    cc.comps.forEach(function(c){
      if (c === best || c.area < best.area * 0.01 || touches(c)) return;
      var gx = Math.max(0, Math.max(best.x0 - c.x1, c.x0 - best.x1)), gy = Math.max(0, Math.max(best.y0 - c.y1, c.y0 - best.y1));
      if (gx + gy <= Math.max(W, H) * 0.02) keep.push(c.id);
    });
    var out = new Uint8Array(N), keptArea = 0;
    for (var i = 0; i < N; i++) if (keep.indexOf(cc.lab[i]) >= 0){ out[i] = 1; keptArea++; }
    // a second, separate piece of similar size means we can't tell which one is the product
    if (second && keep.indexOf(second.id) < 0 && second.area > keptArea * 0.4) return { ambiguous:true };
    return { mask:out };
  }

  var g = close(open(gold, 1), 2);
  var res = pick(g), kind = 'gold';
  if (res && res.mask){
    // add diamonds and white-gold details touching the gold piece
    var both = new Uint8Array(N); for (var i = 0; i < N; i++) both[i] = (gold[i] || neutral[i]) ? 1 : 0;
    both = close(open(both, 1), 2);
    var cc = components(both), ids = {};
    for (var i = 0; i < N; i++) if (res.mask[i] && cc.lab[i]) ids[cc.lab[i]] = 1;
    var grown = new Uint8Array(N), ga = 0, ma = 0, touch = false;
    for (var i = 0; i < N; i++){ if (res.mask[i]) ma++; if (ids[cc.lab[i]]){ grown[i] = 1; ga++; } }
    cc.comps.forEach(function(c){ if (ids[c.id] && touches(c)) touch = true; });
    if (!touch && ga < ma * 2.2) res.mask = grown;
  } else {
    var nres = pick(close(open(neutral, 1), 2));
    if (nres && nres.mask){ res = nres; kind = 'white'; }
    else return { ok:false, reason: (res && res.ambiguous) || (nres && nres.ambiguous) ? 'several-pieces' : 'not-found' };
  }
  var m = res.mask;

  // fill holes: anything not reachable from the border
  var reach = new Uint8Array(N), st = [];
  for (var x = 0; x < W; x++){ st.push(x, (H-1)*W + x); }
  for (var y = 0; y < H; y++){ st.push(y*W, y*W + W-1); }
  while (st.length){ var p = st.pop(); if (reach[p] || m[p]) continue; reach[p] = 1; var x = p % W;
    if (x > 0) st.push(p-1); if (x < W-1) st.push(p+1); if (p >= W) st.push(p-W); if (p < N-W) st.push(p+W); }
  var filled = 0; for (var i = 0; i < N; i++) if (!reach[i] && !m[i]){ m[i] = 1; filled++; }
  var cm = components(m), big = null;
  cm.comps.forEach(function(c){ if (!big || c.area > big.area) big = c; });
  for (var i = 0; i < N; i++) m[i] = (cm.lab[i] === big.id) ? 1 : 0;

  // measure
  var x0 = W, x1 = 0, y0 = H, y1 = 0, area = 0, rows = [];
  for (var y = 0; y < H; y++){ var a = -1, b = -1;
    for (var x = 0; x < W; x++) if (m[y*W+x]){ if (a < 0) a = x; b = x; area++; }
    rows.push(a < 0 ? 0 : b - a + 1);
    if (a >= 0){ if (a < x0) x0 = a; if (b > x1) x1 = b; if (y < y0) y0 = y; y1 = y; } }
  var fullH = y1 - y0 + 1, fullW = x1 - x0 + 1;
  if (Math.max(fullH, fullW) < 45) return { ok:false, reason:'too-small' };
  if (area / (fullH * fullW) < 0.22) return { ok:false, reason:'odd-shape' };
  if (fullH / fullW > 5 || fullW / fullH > 5) return { ok:false, reason:'odd-shape' };
  var area = 0; for (var i = 0; i < N; i++) area += m[i];
  var maxRow = 0; for (var y = y0; y <= y1; y++) maxRow = Math.max(maxRow, rows[y]);
  var bailEnd = y0; while (bailEnd <= y1 && rows[bailEnd] < maxRow * 0.45) bailEnd++;
  var bailH = bailEnd - y0; if (bailH > fullH * 0.4) bailH = 0;
  var bodyH = fullH - bailH, bodyW = 0; for (var y = y0 + bailH; y <= y1; y++) bodyW = Math.max(bodyW, rows[y]);

  // quality features
  var pts = [], per = 0, goldIn = 0, neutIn = 0;
  for (var y = y0; y <= y1; y++) for (var x = x0; x <= x1; x++){
    var o = y*W + x; if (!m[o]) continue;
    if (gold[o]) goldIn++; if (neutral[o]) neutIn++;
    var bnd = x === 0 || y === 0 || x === W-1 || y === H-1 || !m[o-1] || !m[o+1] || !m[o-W] || !m[o+W];
    if (bnd){ per++; pts.push([x, y]); }
  }
  pts.sort(function(a, b){ return a[0] - b[0] || a[1] - b[1]; });
  var cross = function(o, a, b){ return (a[0]-o[0])*(b[1]-o[1]) - (a[1]-o[1])*(b[0]-o[0]); };
  var lower = [], upper = [];
  for (var i = 0; i < pts.length; i++){ while (lower.length >= 2 && cross(lower[lower.length-2], lower[lower.length-1], pts[i]) <= 0) lower.pop(); lower.push(pts[i]); }
  for (var i = pts.length - 1; i >= 0; i--){ while (upper.length >= 2 && cross(upper[upper.length-2], upper[upper.length-1], pts[i]) <= 0) upper.pop(); upper.push(pts[i]); }
  var hull = lower.slice(0, -1).concat(upper.slice(0, -1)), ha = 0;
  for (var i = 0; i < hull.length; i++){ var p1 = hull[i], p2 = hull[(i+1) % hull.length]; ha += p1[0]*p2[1] - p2[0]*p1[1]; }
  ha = Math.abs(ha) / 2;
  var ex = Math.round(Math.max(fullW, fullH) * 0.1), rg = 0, rn = 0;
  for (var y = Math.max(0, y0 - ex); y <= Math.min(H - 1, y1 + ex); y++) for (var x = Math.max(0, x0 - ex); x <= Math.min(W - 1, x1 + ex); x++){
    var o = y*W + x; if (m[o]) continue; rn++; if (gold[o]) rg++;
  }
  var feat = { ringGold: rg / Math.max(1, rn), solidity: area / Math.max(1, ha), ragged: per / Math.sqrt(area), goldFrac: goldIn / area, neutFrac: neutIn / area, filledFrac: filled / area, kind: kind };

  // millimetres per (processing) pixel
  var est = [];
  if (spec.dimsMm){
    var A = spec.dimsMm[0], B = spec.dimsMm[1], rPhoto = bodyH / bodyW;
    var hmm, wmm; if (Math.abs(A / B - rPhoto) <= Math.abs(B / A - rPhoto)){ hmm = A; wmm = B; } else { hmm = B; wmm = A; }
    est.push(hmm / (spec.bail === 'included' ? fullH : bodyH), wmm / bodyW);
  } else {
    if (spec.heightMm) est.push(spec.heightMm / (spec.bail === 'excluded' ? bodyH : fullH));
    if (spec.widthMm) est.push(spec.widthMm / bodyW);
    if (spec.diameterMm) est.push(spec.diameterMm / bodyW);
  }
  if (!est.length) return { ok:false, reason:'no-size' };
  if (est.length > 1){
    var lo = Math.min.apply(null, est), hi = Math.max.apply(null, est);
    if (hi / lo > 1.2) return { ok:false, reason:'shape-mismatch' };
  }
  var mmpp = est.reduce(function(s, v){ return s + v; }, 0) / est.length;

  // cutout at full photo resolution with soft edges
  var mc = document.createElement('canvas'); mc.width = W; mc.height = H;
  var mcx = mc.getContext('2d'), md = mcx.createImageData(W, H);
  for (var i = 0; i < N; i++){ md.data[i*4+3] = m[i] ? 255 : 0; }
  mcx.putImageData(md, 0, 0);
  var pad = 1, ox = Math.max(0, x0 - pad), oy = Math.max(0, y0 - pad), ow = Math.min(W, x1 + pad + 1) - ox, oh = Math.min(H, y1 + pad + 1) - oy;
  var k = 1 / sc, out = document.createElement('canvas');
  out.width = Math.round(ow * k); out.height = Math.round(oh * k);
  var ocx = out.getContext('2d');
  ocx.drawImage(img, ox * k, oy * k, ow * k, oh * k, 0, 0, out.width, out.height);
  ocx.globalCompositeOperation = 'destination-in';
  ocx.imageSmoothingEnabled = true; ocx.imageSmoothingQuality = 'high';
  ocx.filter = 'blur(' + Math.max(0.6, k * 0.7) + 'px)';
  ocx.drawImage(mc, ox, oy, ow, oh, 0, 0, out.width, out.height);
  ocx.filter = 'none';
  return { ok:true, feat:feat, kind:kind, canvas:out, boxHmm: oh * mmpp, boxWmm: ow * mmpp, heightMm: fullH * mmpp, widthMm: fullW * mmpp, mmPerPx: mmpp, fullH:fullH, bailH:bailH };
}

/* ================= Actual size viewer ================= */
(function(){
  if (window.__actualSizeReady) return;
  window.__actualSizeReady = true;

  var CARD_SHORT_MM = 53.98, QUARTER_MM = 24.26, CAL_KEY = 'ringsizer.pxPerMm';
  // Pendants whose automatic cutout was checked by hand and looks right
  var APPROVED = ["siddhartha-gautama-buddha-head-pendant", "wolf-fully-diamond-pendant", "square-filigree-memorial-diamond-pendant", "lady-buddha-guan-yin-diamond-framed-pendant", "cancer-ribbon-diamond-pendant", "double-sided-jesus-virgin-mary-diamond-oval-pendant", "cursive-l-diamond-pendant", "god-of-war-guan-gong-face-rectangular-pendant", "money-frog-and-dragon-pendant", "bayon-face-tower-cambodian-pendant", "saint-michael-archangel-portrait-artwork-pendant", "diamond-cut-dragon-skull-and-tiger-pendant", "diamond-cut-michelangelos-pieta-circular-pendant", "detailed-crucifix-pendant", "3d-god-of-war-guan-gong-with-a-dragon-and-customizable-bail-pendant", "polish-eagle-round-diamond-pendant", "lady-buddha-guan-yin-diamond-pendant", "crying-angel-diamond-pendant", "foo-dog-diamond-framed-pendant", "diamond-cut-sun-pendant", "diamond-cut-saint-jude-with-filigree-border-pendant", "jesus-face-pendant"];
  var cache = {};

  function loadCal(){ try { var v = parseFloat(localStorage.getItem(CAL_KEY)); return v > 0 ? v : null; } catch(e){ return null; } }
  function saveCal(v){ try { localStorage.setItem(CAL_KEY, String(v)); } catch(e){} }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }
  function fmtMm(v){ return (Math.round(v * 10) / 10).toString().replace(/\.0$/, '') + ' mm'; }
  var ALIAS = { 'solid-figaro-chain':'solid-plain-figaro-chain', 'solid-nugget-link-chain':'solid-nugget-chain', 'solid-mariner-chain':'solid-plain-mariner-chain',
    'semi-hollow-baht-link-chain':'semi-hollow-baht-chain', 'solid-gold-dragon-scale-chain':'solid-dragon-scale-chain', 'solid-dragon-biting-tail-scale-chain':'solid-dragon-scale-chain' };
  function styleKey(title){
    var k = String(title).replace(/^\s*[\d.]+\s*mm\s*/i, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').replace(/-bracelet$/, '-chain');
    return ALIAS[k] || k;
  }
  function chainWidth(title){ var m = String(title).match(/(\d+(?:\.\d+)?)\s*mm/i); return m ? parseFloat(m[1]) : null; }
  function accept(f){ return f && f.kind === 'gold' && (f.ringGold < 0.02 || (f.ringGold < 0.05 && f.solidity >= 0.75 && f.ragged <= 6.5)); }

  var state = { ppm: loadCal(), data: null, chainMm: 0 };

  /* ---------- sheet ---------- */
  var overlay = document.createElement('div');
  overlay.className = 'as-overlay'; overlay.setAttribute('aria-hidden', 'true');
  overlay.innerHTML = '<div class="as-sheet" role="dialog" aria-modal="true" aria-label="Actual size">' +
    '<div class="as-top"><span style="width:36px"></span><h2>Actual size</h2><button class="as-icon" data-as-close type="button" aria-label="Close">&times;</button></div>' +
    '<div class="as-body"></div></div>';
  function mount(){ if (!overlay.parentNode) document.body.appendChild(overlay); }
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);
  var body = overlay.querySelector('.as-body'), sheet = overlay.querySelector('.as-sheet'), lastFocus = null;

  function open(root){
    mount();
    try { state.data = JSON.parse(root.querySelector('[data-as-json]').textContent); } catch(e){ return; }
    lastFocus = document.activeElement; state.chainMm = 0;
    overlay.classList.add('as-open'); overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    calibrate();   // always confirm the card first; a saved size is pre-filled
    overlay.querySelector('[data-as-close]').focus();
  }
  function close(){
    overlay.classList.remove('as-open'); overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    var t = (lastFocus && document.contains(lastFocus)) ? lastFocus : document.querySelector('[data-as-open]');
    if (t) t.focus();
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-as-open]');
    if (b){ e.preventDefault(); state.mode = b.getAttribute('data-as-open') || ''; open(b.closest('[data-actual-size]')); }
  });
  overlay.addEventListener('click', function(e){ if (e.target === overlay || (e.target.closest && e.target.closest('[data-as-close]'))) close(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && overlay.classList.contains('as-open')) close(); });
  function show(){
    var t = state.data.type;
    (t === 'pendant' ? pendantView : (t === 'bracelet' && state.mode === 'wrist') ? wristMeasure : chainView)();
    sheet.scrollTop = 0;
  }
  function recalLink(){ return '<button class="as-link" data-as-recal type="button">Screen size looks wrong? Match the card again</button>'; }
  function bindRecal(){ var r = body.querySelector('[data-as-recal]'); if (r) r.addEventListener('click', calibrate); }

  /* ---------- calibration (shared with the ring sizer) ---------- */
  function calibrate(){
    var maxW = Math.min(420, body.clientWidth - 40);
    var defW = state.ppm ? state.ppm * CARD_SHORT_MM : CARD_SHORT_MM * 96 / 25.4 * (window.devicePixelRatio > 1.5 ? 1.5 : 1);
    var w = Math.max(120, Math.min(maxW, defW));
    body.innerHTML =
      '<h3>First, match your screen to a card</h3>' +
      '<p class="as-lead">Every screen is a different size, so this lets us show the piece exactly. Hold any bank or ID card upright against the screen, top edge on the gold line, and adjust until the outline is as wide as the card.</p>' +
      (state.ppm ? '<p class="as-saved">We\'ve set it to your last measurement. Hold your card up to check it still lines up.</p>' : '') +
      '<div class="as-stage as-cal" data-stage><div class="as-card" data-card><span>Card width</span></div></div>' +
      '<div class="as-control"><button class="as-step" type="button" data-d="-1" aria-label="Narrower">&minus;</button>' +
      '<input type="range" data-range min="120" max="' + maxW + '" step="0.5" value="' + w + '" aria-label="Card outline width">' +
      '<button class="as-step" type="button" data-d="1" aria-label="Wider">+</button></div>' +
      '<p class="as-hint">You only need to do this once on this device.</p>' +
      '<div class="as-actions"><button class="as-primary" data-done type="button">The outline matches</button></div>';
    var card = body.querySelector('[data-card]'), stage = body.querySelector('[data-stage]'), range = body.querySelector('[data-range]');
    function draw(){ card.style.width = w + 'px'; card.style.height = (w * 0.9) + 'px'; stage.style.height = (w * 0.9 + 24) + 'px'; range.value = w; }
    draw();
    range.addEventListener('input', function(){ w = parseFloat(range.value); draw(); });
    Array.prototype.forEach.call(body.querySelectorAll('.as-step'), function(b){ b.addEventListener('click', function(){ w = Math.max(120, Math.min(maxW, w + parseFloat(b.dataset.d))); draw(); }); });
    body.querySelector('[data-done]').addEventListener('click', function(){ state.ppm = w / CARD_SHORT_MM; saveCal(state.ppm); show(); });
  }

  /* ---------- shared drawing ---------- */
  function ruler(mm, ppm){
    var h = mm * ppm, t = '';
    for (var i = 0; i <= Math.floor(mm); i++){
      var y = 1 + i * ppm, len = i % 10 === 0 ? 12 : i % 5 === 0 ? 8 : 4;
      t += '<line x1="' + (22 - len) + '" y1="' + y + '" x2="22" y2="' + y + '" stroke="currentColor" stroke-width="' + (i % 10 === 0 ? 1.1 : 0.7) + '"/>';
      if (i % 10 === 0 && i > 0) t += '<text x="' + (22 - len - 3) + '" y="' + (y + 3.5) + '" font-size="9" text-anchor="end" fill="currentColor">' + i + '</text>';
    }
    t += '<line x1="22" y1="1" x2="22" y2="' + (1 + h) + '" stroke="currentColor"/>';
    return '<svg class="as-ruler" width="24" height="' + (h + 2) + '" aria-hidden="true">' + t + '</svg>';
  }
  function coin(ppm){ return '<div class="as-coin" style="width:' + QUARTER_MM * ppm + 'px;height:' + QUARTER_MM * ppm + 'px">US<br>quarter</div>'; }
  function chainStrip(mm, ppm, key){
    var c = state.data.chains && state.data.chains[key];
    if (!c) return 'height:' + mm * ppm + 'px;background:linear-gradient(to bottom,#8a6a1f,#e9cf7a 35%,#f6e7a8 50%,#c9a44a 70%,#7d5f1a);border-radius:' + mm * ppm / 2 + 'px';
    var s = mm / c.c * ppm;
    return 'height:' + c.h * s + 'px;background-image:url(\'' + c.u + '\');background-repeat:repeat-x;background-position:left center;background-size:' + c.w * s + 'px ' + c.h * s + 'px';
  }

  /* ---------- pendants ---------- */
  function pendantView(){
    var d = state.data, spec = parsePendantSpec(d.text);
    if (!spec){
      body.innerHTML = '<h3>' + esc(d.title) + '</h3><p class="as-lead">This pendant\'s size isn\'t listed yet, so we can\'t show it at actual size. Contact us and we\'ll measure it for you.</p>';
      return;
    }
    var cached = cache[d.handle];
    if (cached){ render(cached); return; }
    body.innerHTML = '<h3>' + esc(d.title) + ' at actual size</h3><p class="as-lead">Preparing the pendant&hellip;</p>';
    if (!d.image){ cache[d.handle] = { ok:false }; render(cache[d.handle]); return; }
    var img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = function(){
      var r; try { r = detectPendant(img, spec); } catch(e){ r = { ok:false }; }
      if (r.ok && !(accept(r.feat) || APPROVED.indexOf(d.handle) >= 0)) r = { ok:false, reason:'low-confidence' };
      cache[d.handle] = r; if (overlay.classList.contains('as-open') && state.data === d) render(r);
    };
    img.onerror = function(){ cache[d.handle] = { ok:false }; if (state.data === d) render(cache[d.handle]); };
    img.src = d.image;

    function facts(){
      var f = '<div class="as-facts"><div><small>Listed size</small><b>' + esc(spec.raw.replace(/\s*[,;]\s*$/, '')) + '</b></div>';
      if (spec.bailMm) f += '<div><small>Bail fits chains</small><b>Up to ' + fmtMm(spec.bailMm) + '</b></div>';
      return f + '</div>';
    }
    function render(r){
      var ppm = state.ppm;
      if (r.ok){
        var hPx = r.boxHmm * ppm, wPx = r.boxWmm * ppm, widths = [2, 3, 4, 5, 6];
        if (spec.bailMm && spec.bailMm > 6) widths.push(Math.floor(spec.bailMm));
        var chips = '<button class="as-chip" type="button" data-c="0" aria-pressed="' + !state.chainMm + '">Pendant only</button>' +
          widths.map(function(w){ return '<button class="as-chip" type="button" data-c="' + w + '" aria-pressed="' + (state.chainMm === w) + '">On a ' + w + ' mm chain</button>'; }).join('');
        var fit = '';
        if (state.chainMm && spec.bailMm) fit = state.chainMm <= spec.bailMm
          ? '<p class="as-fit as-ok">A ' + state.chainMm + ' mm chain fits through this bail.</p>'
          : '<p class="as-fit as-no">A ' + state.chainMm + ' mm chain is wider than this bail allows (up to ' + fmtMm(spec.bailMm) + ').</p>';
        body.innerHTML =
          '<h3>' + esc(d.title) + ' at actual size</h3>' +
          '<p class="as-lead">Lay your phone flat. This is how big the pendant is in real life.</p>' +
          '<div class="as-chips" role="group" aria-label="Show on a chain">' + chips + '</div>' + fit +
          '<div class="as-stage as-p" data-pstage>' +
            '<div class="as-pwrap">' + ruler(r.heightMm, ppm) + '<span data-cut></span></div>' + coin(ppm) +
            (state.chainMm ? '<div class="as-pchain" style="top:' + (30 + Math.min(3, r.heightMm * 0.06) * ppm) + 'px;transform:translateY(-50%);' + chainStrip(state.chainMm, ppm, 'solid-miami-cuban-link-chain') + '"></div>' : '') +
          '</div>' + facts() +
          '<p class="as-hint">Size is based on the listed dimensions. Width may be off by a millimeter or so.</p>' + recalLink();
        var cv = r.canvas; cv.className = 'as-cut'; cv.style.height = hPx + 'px'; cv.style.width = wPx + 'px';
        cv.setAttribute('role', 'img'); cv.setAttribute('aria-label', d.title + ' shown at actual size');
        body.querySelector('[data-cut]').replaceWith(cv);
        Array.prototype.forEach.call(body.querySelectorAll('.as-chip'), function(b){ b.addEventListener('click', function(){ state.chainMm = parseFloat(b.dataset.c); render(r); }); });
      } else {
        // outline of the listed size
        var H = spec.heightMm, W = spec.widthMm, D = spec.diameterMm, shape = '';
        if (spec.dimsMm){ H = Math.max(spec.dimsMm[0], spec.dimsMm[1]); W = Math.min(spec.dimsMm[0], spec.dimsMm[1]); if (spec.dimsMm[0] === spec.dimsMm[1]) D = H; }
        if (D) shape = '<div class="as-outline" style="width:' + D * ppm + 'px;height:' + D * ppm + 'px;border-radius:50%"><span>' + fmtMm(D) + '<br>across</span></div>';
        else if (H && W) shape = '<div class="as-outline" style="width:' + W * ppm + 'px;height:' + H * ppm + 'px;border-radius:' + Math.min(W, H) * ppm * 0.12 + 'px"><span>' + fmtMm(H) + '<br>by ' + fmtMm(W) + '</span></div>';
        else if (H) shape = '<div class="as-hbar" style="height:' + H * ppm + 'px"><span>' + fmtMm(H) + ' tall</span></div>';
        else if (W) shape = '<div class="as-wbar" style="width:' + W * ppm + 'px"><span>' + fmtMm(W) + ' wide</span></div>';
        var bailNote = spec.bail === 'excluded' ? ' The bail adds a little extra height on top.' : '';
        body.innerHTML =
          '<h3>' + esc(d.title) + ' at actual size</h3>' +
          '<p class="as-lead">Lay your phone flat. The outline shows the pendant\'s real size, next to a quarter for comparison.' + bailNote + '</p>' +
          '<div class="as-stage as-p">' + ((H || D) ? ruler(H || D, ppm) : '') + shape + coin(ppm) + '</div>' + facts() + recalLink();
      }
      bindRecal();
    }
  }


  /* ---------- bracelets: wrist sizer ---------- */
  var FIT = { snug: { label:'Snug', add:0.5, note:'Sits close to the wrist with little movement.' },
              comfortable: { label:'Comfortable', add:1.0, note:'Moves freely without sliding far down the hand. Most people choose this.' },
              loose: { label:'Loose', add:1.5, note:'Drapes and slides a little, for a relaxed look.' } };
  function lengthIn(v){ var m = String(v).match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : NaN; }
  function fmtIn(v){ return (Math.round(v * 4) / 4).toString() + ' in'; }

  function wristMeasure(){
    var d = state.data, ppm = state.ppm, maxMm = 115, pad = 10, h = Math.round(maxMm * ppm + pad * 2);
    if (!state.halfMm) state.halfMm = 83;
    body.innerHTML =
      '<h3>Measure your wrist</h3>' +
      '<ol class="as-steps"><li>Wrap a thin strip of paper around your wrist, just above the wrist bone, where the bracelet will sit. Keep it snug but not tight, and mark where the end overlaps.</li>' +
      '<li>Fold the strip in half so the end meets your mark.</li>' +
      '<li>Hold the strip against the ruler with the fold at 0, then drag the gold line to where the ends meet.</li></ol>' +
      '<div class="as-wwrap"><div class="as-stage as-wstage" style="width:104px"><svg data-ruler width="104" height="' + h + '" style="cursor:ns-resize;display:block"></svg></div>' +
      '<div class="as-wside"><p class="as-wlabel">Your wrist</p><p class="as-wbig" data-wbig></p><p class="as-hint" data-wsmall></p>' +
      '<div class="as-field"><label for="as-wtype">Have a tape measure? Type it instead</label><div class="as-frow"><input id="as-wtype" type="number" inputmode="decimal" step="0.1" min="4" max="30" placeholder="6.5">' +
      '<select data-unit aria-label="Unit"><option value="in">in</option><option value="cm">cm</option></select></div></div></div></div>' +
      '<div class="as-actions"><button class="as-primary" data-next type="button">Show my bracelet size</button></div>' + recalLink();
    var svg = body.querySelector('[data-ruler]'), ticks = '';
    for (var mm = 0; mm <= maxMm; mm++){
      var y = pad + mm * ppm, len = mm % 10 === 0 ? 30 : mm % 5 === 0 ? 20 : 11;
      ticks += '<line x1="0" y1="' + y + '" x2="' + len + '" y2="' + y + '" stroke="currentColor" stroke-width="' + (mm % 10 === 0 ? 1.2 : .7) + '"/>';
      if (mm % 10 === 0) ticks += '<text x="36" y="' + (y + 4) + '" font-size="11" fill="currentColor">' + mm + '</text>';
    }
    function draw(){
      var y = pad + state.halfMm * ppm, wrist = state.halfMm * 2;
      svg.innerHTML = ticks + '<rect x="0" y="' + pad + '" width="8" height="' + state.halfMm * ppm + '" fill="var(--as-gold)" opacity=".25"/>' +
        '<line x1="0" y1="' + y + '" x2="104" y2="' + y + '" stroke="var(--as-gold)" stroke-width="2.5"/><circle cx="90" cy="' + y + '" r="8" fill="var(--as-gold)"/>';
      body.querySelector('[data-wbig]').textContent = fmtIn(wrist / 25.4);
      body.querySelector('[data-wsmall]').textContent = (wrist / 10).toFixed(1) + ' cm around (the folded strip is ' + Math.round(state.halfMm) + ' mm)';
    }
    draw();
    function setFromY(cy){ var r = svg.getBoundingClientRect(); state.halfMm = Math.max(50, Math.min(maxMm, Math.round((cy - r.top - pad) / ppm * 2) / 2)); body.querySelector('#as-wtype').value = ''; draw(); }
    var dragging = false;
    svg.addEventListener('pointerdown', function(e){ dragging = true; svg.setPointerCapture(e.pointerId); setFromY(e.clientY); });
    svg.addEventListener('pointermove', function(e){ if (dragging) setFromY(e.clientY); });
    svg.addEventListener('pointerup', function(){ dragging = false; });
    var inp = body.querySelector('#as-wtype'), unit = body.querySelector('[data-unit]');
    function typed(){
      var v = parseFloat(inp.value); if (!(v > 0)) return;
      var mmv = unit.value === 'cm' ? v * 10 : v * 25.4;
      if (mmv >= 100 && mmv <= 230){ state.halfMm = mmv / 2; draw(); }
    }
    inp.addEventListener('input', typed); unit.addEventListener('change', typed);
    body.querySelector('[data-next]').addEventListener('click', function(){ wristResult(); sheet.scrollTop = 0; });
    bindRecal();
  }

  function wristResult(){
    var d = state.data, wristIn = state.halfMm * 2 / 25.4, fit = state.fit || 'comfortable';
    var w = chainWidth(d.title) || 0;
    var extra = w > 3 ? Math.PI * 0.45 * (w - 3) / 25.4 : 0;     // wide links take up room inside the bracelet
    var ideal = wristIn + FIT[fit].add + extra;
    var opts = (d.lengths || []).map(function(v){ return { value: v, inches: lengthIn(v) }; }).filter(function(o){ return !isNaN(o.inches); })
                 .sort(function(a, b){ return a.inches - b.inches; });
    var pick = null;
    for (var i = 0; i < opts.length; i++){ if (opts[i].inches >= ideal - 0.12){ pick = opts[i]; break; } }
    var note = '';
    if (!opts.length) note = '';
    else if (!pick){ note = 'Our longest length for this bracelet is ' + opts[opts.length - 1].value + '. Contact us about a custom length.'; }
    else if (i === 0 && ideal < opts[0].inches - 0.5){ note = 'This is the shortest length we offer for this bracelet. It will fit a little looser than you chose.'; }
    var chips = Object.keys(FIT).map(function(k){ return '<button class="as-chip" type="button" data-fit="' + k + '" aria-pressed="' + (k === fit) + '">' + FIT[k].label + '</button>'; }).join('');
    body.innerHTML =
      '<p class="as-lead" style="margin:0">Your wrist is ' + fmtIn(wristIn) + ' (' + (wristIn * 2.54).toFixed(1) + ' cm)</p>' +
      '<p class="as-wlabel" style="margin-top:14px">How do you like it to fit?</p><div class="as-chips">' + chips + '</div>' +
      '<p class="as-hint" style="margin-top:-4px">' + FIT[fit].note + '</p>' +
      '<p class="as-lead" style="margin:18px 0 0">Recommended length</p>' +
      '<div class="as-result">' + (pick ? esc(pick.value) : fmtIn(ideal)) + '</div>' +
      '<p class="as-hint">' + fmtIn(wristIn) + ' wrist + ' + fmtIn(FIT[fit].add) + ' for a ' + FIT[fit].label.toLowerCase() + ' fit' +
        (extra >= 0.1 ? ' + ' + fmtIn(extra) + ' because ' + fmtMm(w) + ' links take up room inside the bracelet' : '') + '.</p>' +
      (note ? '<p class="as-note">' + note + '</p>' : '') +
      '<p class="as-note" data-msg hidden></p>' +
      '<div class="as-actions">' + (pick ? '<button class="as-primary" data-use type="button">Select ' + esc(pick.value) + '</button>' : '') +
      '<button class="as-secondary" data-again type="button">Measure again</button></div>';
    Array.prototype.forEach.call(body.querySelectorAll('[data-fit]'), function(b){ b.addEventListener('click', function(){ state.fit = b.dataset.fit; wristResult(); }); });
    body.querySelector('[data-again]').addEventListener('click', wristMeasure);
    var use = body.querySelector('[data-use]');
    if (use) use.addEventListener('click', function(){
      if (selectOptionValue(pick.value, d.lengthOption)) close();
      else { var m = body.querySelector('[data-msg]'); m.hidden = false; m.textContent = 'Choose ' + pick.value + ' from the length options on the page.'; }
    });
  }

  // Picks an option value on the product form (Horizon radios or a dropdown), skipping other products' pickers
  function selectOptionValue(val, optionName){
    function usable(el){ return !overlay.contains(el) && !el.closest('product-card, quick-add-dialog, .product-card, [data-actual-size], [data-ring-sizer]'); }
    function same(el){ var n = el.getAttribute('data-option-name'); return !n || !optionName || n === optionName; }
    function inScope(scope){
      var radios = scope.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++){ var r = radios[i]; if (r.value === val && usable(r) && same(r)){ if (!r.checked) r.click(); return true; } }
      var sels = scope.querySelectorAll('select');
      for (var j = 0; j < sels.length; j++){ var s = sels[j]; if (!usable(s)) continue;
        for (var k = 0; k < s.options.length; k++){ var o = s.options[k];
          if ((o.value === val || o.text.trim() === val) && same(o)){ if (s.selectedIndex !== k){ s.selectedIndex = k; s.dispatchEvent(new Event('change', { bubbles:true })); } return true; } } }
      return false;
    }
    var root = document.querySelector('[data-actual-size]');
    var section = root && (root.closest('.shopify-section') || root.closest('main'));
    return (section && inScope(section)) || inScope(document.querySelector('main') || document);
  }

  /* ---------- chains ---------- */
  function chainView(){
    var d = state.data, ppm = state.ppm, w = chainWidth(d.title), key = styleKey(d.title);
    if (!w){ body.innerHTML = '<h3>' + esc(d.title) + '</h3><p class="as-lead">This chain\'s width isn\'t listed.</p>'; return; }
    var widths = [w - 1, w, w + 1].filter(function(v){ return v >= 1; });
    var rows = widths.map(function(v){
      var me = v === w;
      return '<div class="as-crow' + (me ? ' as-this' : '') + '"><div class="as-clabel"><b>' + fmtMm(v) + (me ? (d.type === 'bracelet' ? ', this bracelet' : ', this chain') : '') + '</b><span>' + (me ? '' : 'Same style, for comparison') + '</span></div>' +
        '<div class="as-cstrip" role="img" aria-label="' + v + ' millimeter chain at actual width" style="' + chainStrip(v, ppm, key) + '"></div></div>';
    }).join('');
    body.innerHTML =
      '<h3>' + esc(d.title) + ' at actual width</h3>' +
      '<p class="as-lead">Lay your phone flat. The highlighted strip is exactly as thick as this ' + (d.type === 'bracelet' ? 'bracelet' : 'chain') + '.</p>' +
      '<div class="as-stage as-c">' + rows + '<div class="as-scale"><i style="width:' + 10 * ppm + 'px"></i><span>1 cm</span></div></div>' +
      '<p class="as-hint">' + (d.type === 'bracelet' ? 'Length doesn\'t change the width. Use &ldquo;Find my bracelet size&rdquo; to choose a length.' : 'Length doesn\'t change the width. To wear it with a pendant, check that the pendant\'s bail fits a ' + fmtMm(w) + ' chain.') + '</p>' + recalLink();
    bindRecal();
  }
})();
